module.exports = __webpack_public_path__ + "static/assets/6194c93a8b5ab4f1807e4da5dd535b29.png";